import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/no-image.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-ac62b3d0")

_pushScopeId("data-v-ac62b3d0")
const _hoisted_1 = { id: "PickUpTalents" }
const _hoisted_2 = { class: "pick-up-talents" }
const _hoisted_3 = { class: "pick-up-talents-container" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", { class: "txt txt-headline" }, "おすすめタレント", -1)
const _hoisted_5 = { class: "pick-up-talents-list" }
const _hoisted_6 = {
  key: 0,
  class: "pick-up-img",
  src: _imports_0
}
const _hoisted_7 = { class: "talent-name txt txt-small" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Imgix = _resolveComponent("Imgix")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pickupTalents, (pickupTalent, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "pick-up-talent-box",
              onClick: ($event: any) => (_ctx.openTalent(pickupTalent.talentID))
            }, [
              (pickupTalent.mainImage === '')
                ? (_openBlock(), _createBlock("img", _hoisted_6))
                : (_openBlock(), _createBlock(_component_Imgix, {
                    key: 1,
                    class: "pick-up-img",
                    imageUrl: pickupTalent.mainImage,
                    imageSize: _ctx.imageSize
                  }, null, 8, ["imageUrl", "imageSize"])),
              _createVNode("div", _hoisted_7, _toDisplayString(pickupTalent.formatDisplayName), 1)
            ], 8, ["onClick"]))
          }), 256))
        ])
      ])
    ])
  ]))
})